"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledDownloadListItem = exports.StyledDownloadList = exports.StyledQuoteButton = exports.StyledQuoteButtonsWrapper = exports.StyledFormWrapper = exports.StyledHeader = void 0;
const ui_1 = require("@phishtool/ui");
const styled_components_1 = __importDefault(require("styled-components"));
exports.StyledHeader = styled_components_1.default.div.withConfig({ displayName: "StyledHeader", componentId: "sc-1awu3ya" }) `
  background: ${(props) => props.theme.colors.solitude};
  border-bottom: 1px solid ${(props) => props.theme.colors.silverPearl};
  padding: ${(props) => props.theme.spacers.x6} 0;
  margin-bottom: ${(props) => props.theme.spacers.x9};
`;
exports.StyledFormWrapper = styled_components_1.default.div.withConfig({ displayName: "StyledFormWrapper", componentId: "sc-17s1624" }) `
  margin: 0 auto;

  ${(0, ui_1.mq)({
    maxWidth: ['325px', '630px'],
})}

  .input-wrapper {
    ${(props) => (0, ui_1.mq)({
    marginBottom: [props.theme.spacers.x3, props.theme.spacers.x6],
})}
  }

  .code-input-wrapper {
    justify-content: space-between;

    input {
      padding: 0;
      text-align: center;

      ${(0, ui_1.mq)({
    width: ['40px', '90px'],
    height: ['40px', '90px'],
    fontSize: ['24px', '34px'],
})}
    }
  }
`;
exports.StyledQuoteButtonsWrapper = styled_components_1.default.div.withConfig({ displayName: "StyledQuoteButtonsWrapper", componentId: "sc-10w1esr" }) `
  display: grid;
  grid-template-columns: max-content max-content max-content;
  gap: ${(props) => props.theme.spacers.x3};
  justify-content: center;
  align-items: center;
  margin-bottom: ${(props) => props.theme.spacers.x9};

  ${(0, ui_1.mq)({
    gridTemplateColumns: ['max-content', 'repeat(2, max-content)', 'repeat(3, max-content)'],
})}
`;
exports.StyledQuoteButton = styled_components_1.default.a.withConfig({ displayName: "StyledQuoteButton", componentId: "sc-1i356a5" }) `
  display: flex;
  flex-direction: column;
  gap: ${(props) => props.theme.spacers.x3};
  font-weight: ${(props) => props.theme.fontWeights.semiBold};
  text-decoration: none;
  align-items: center;
  border: 1px solid ${(props) => props.theme.colors.silverPearl};
  border-radius: ${(props) => props.theme.radii.primary};
  padding: ${(props) => props.theme.spacers.x4} 0;
  width: 225px;

  ${(props) => props.$disabled &&
    `
    cursor: not-allowed;
  `}

  &,
  &:focus,
  &:active,
  &:visited {
    color: ${(props) => props.theme.colors.oxfordBlue};
  }

  ${(props) => props.theme.responsiveTypography.body.medium};

  svg {
    color: ${(props) => (0, ui_1.hexToRgba)(props.theme.colors.oxfordBlue, 0.2)};
  }

  &:hover {
    color: ${(props) => props.theme.colors.heroOrange};
    border-color: ${(props) => props.theme.colors.heroOrange};
    svg {
      color: ${(props) => props.theme.colors.heroOrange};
    }
  }
`;
exports.StyledDownloadList = styled_components_1.default.ul.withConfig({ displayName: "StyledDownloadList", componentId: "sc-154z2mb" }) `
  list-style: none;
  border-top: 1px solid ${(props) => props.theme.colors.silverPearl};
  margin: 0 0 ${(props) => props.theme.spacers.x12};
  padding: 0;
  min-height: 200px;
  max-height: 250px;
  overflow: auto;
`;
exports.StyledDownloadListItem = styled_components_1.default.li.withConfig({ displayName: "StyledDownloadListItem", componentId: "sc-6llgng" }) `
  ${(props) => props.theme.typography.x2}
  border-bottom: ${(props) => `1px solid ${(0, ui_1.hexToRgba)(props.theme.colors.silverPearl, 0.5)}`};
  padding: ${(props) => props.theme.spacers.x1} 0;
`;
